module.exports = __webpack_public_path__ + "img/success.a43dd83a.png";